export class GLTexture {
    _gl: any;
    _texture: any;
    enable: boolean;

    constructor(gl) {
        var self = this;
        self._gl = gl;
        self._texture = null;
        self.enable = true;
    }

    static createTexture2d(gl, linear) {
        var result = new GLTexture(gl);
        var texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, linear ? gl.LINEAR : gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.bindTexture(gl.TEXTURE_2D, null);
        result._texture = texture;
        return result;
    }

    setPixels(image) {
        var self = this;
        self._gl.bindTexture(self._gl.TEXTURE_2D, self._texture);
        self._gl.texImage2D(self._gl.TEXTURE_2D, 0, self._gl.RGBA, self._gl.RGBA, self._gl.UNSIGNED_BYTE, image);
        self._gl.generateMipmap(self._gl.TEXTURE_2D);
        self._gl.bindTexture(self._gl.TEXTURE_2D, null);
    }

    bind() {
        var self = this;
        self._gl.bindTexture(self._gl.TEXTURE_2D, self._texture);
    }

    unbind() {
        var self = this;
        self._gl.bindTexture(self._gl.TEXTURE_2D, null);
    }

    destroy() {
        var self = this;
        self._gl.deleteTexture(self._texture);
    }

}
